import moment from "moment"
import MyTooltip from "@common-utils/MyTooltip"
import { useContext } from "react"
import { CraUpdateGrilleTempsSalarieContext } from "./index"
import { IheuresParRefMissionParJourModel } from "./models"

const TbodyTrHeuresTravailParRefMission = () => {
     const {
          editionModeEnabled,
          heuresParRefMissionParJour,
          setModalFillAllRowRefMissionWithHeures,
          setModalAddMissionRowIsShown,
          handleRemoveMissionRow,
          setModifyHeuresTravailCellInModal,
          data,
     } = useContext(CraUpdateGrilleTempsSalarieContext)

     // Column for type horaire: classique, matin, aprem, nuit, 8-2, 8-3
     const ColumnsHeures = ({ item, matinApremOuNuit }: { item: IheuresParRefMissionParJourModel; matinApremOuNuit: "matin" | "aprem" | "nuit" }) => {
          return (
               <>
                    {/* Columns related to days */}
                    {data.consultantCraDetails.map((craDetails, key_) => {
                         // Chaque réf de mission doit avoir toute la ligne d'initialisé (chaque jour doit avoir une heure)
                         const rowReferenceMission = heuresParRefMissionParJour.find(item_ => item_.refMission == item.refMission)!.items
                         const cellHeures = rowReferenceMission.find(item__ => item__.jour.format("DD/MM/YYYY") == craDetails.date.format("DD/MM/YYYY"))
                         const heures = (() => {
                              if (matinApremOuNuit === "matin") {
                                   return cellHeures?.heuresMatin != null ? cellHeures.heuresMatin : ""
                              }
                              if (matinApremOuNuit === "aprem") {
                                   return cellHeures?.heuresAprem != null ? cellHeures.heuresAprem : ""
                              }
                              if (matinApremOuNuit === "nuit") {
                                   return cellHeures?.heuresNuit != null ? cellHeures.heuresNuit : ""
                              }
                         })()

                         return editionModeEnabled ? (
                              <td
                                   className={`text-center heuresCell ${[5, 6].includes(craDetails.date.weekday()) && "isWeekendCell"} ${
                                        moment().format("YYYYMMDD") == craDetails.date.format("YYYYMMDD") && "isTodayCell"
                                   }`}
                                   onClick={() =>
                                        setModifyHeuresTravailCellInModal({
                                             cra_id: data.id,
                                             mission_id: item.idMission,
                                             mission_ref: item.refMission,
                                             heuresParDefaut: cellHeures!.heuresMatin || 0,
                                             date: craDetails.date,
                                             matinApremOuNuit,
                                        })
                                   }
                                   key={key_}
                              >
                                   <span>{heures}</span>
                              </td>
                         ) : (
                              <td
                                   className={`text-center heuresCell ${[5, 6].includes(craDetails.date.weekday()) && "isWeekendCell"} ${
                                        moment().format("YYYYMMDD") == craDetails.date.format("YYYYMMDD") && "isTodayCell"
                                   }`}
                                   key={key_}
                              >
                                   <span>{heures} </span>
                              </td>
                         )
                    })}
               </>
          )
     }

     return (
          <>
               <tr>
                    <td scope="row" className={"border-end sticky-column"}>
                         <span
                              className={"d-flex align-items-center text-primary fw-bold ps-sm-2"}
                              onClick={() => {
                                   editionModeEnabled && setModalAddMissionRowIsShown(true)
                              }}
                         >
                              ACTIVITÉS
                              {editionModeEnabled && (
                                   <MyTooltip title={"Ajouter une ligne d'activité"}>
                                        <i className={"fas fa-plus-circle btn btn-color-success ps-2 fs-2 p-0"}></i>
                                   </MyTooltip>
                              )}
                         </span>
                    </td>
               </tr>

               {heuresParRefMissionParJour.map((item, key) =>
                    item.mission.typeHoraire === "HORAIRE_ALTERNE_3_PLAGES" ||
                    item.mission.typeHoraire === "HORAIRE_ALTERNE_2_PLAGES_MATIN_APREM" ||
                    item.mission.typeHoraire === "HORAIRE_ALTERNE_2_PLAGES_MATIN_NUIT" ? (
                         <>
                              <tr>
                                   {/* First column with ref of the mission + suppress buttons */}
                                   <td className={"ps-sm-6 border-end sticky-column"} style={{ fontSize: "0.8rem" }}>
                                        <MyTooltip title={"Supprimer cette ligne d'activité"}>
                                             <i
                                                  className={"fas fa-minus-circle btn btn-color-danger fs-4 me-sm-2 me-4 p-0"}
                                                  onClick={() => handleRemoveMissionRow(item.idMission, item.refMission)}
                                             ></i>
                                        </MyTooltip>
                                        {item.refMission}
                                   </td>
                              </tr>
                              <tr>
                                   <td className={"ps-sm-10 border-end sticky-column fw-light fst-italic text-warning"} style={{ fontSize: "0.8rem" }}>
                                        {editionModeEnabled && (
                                             <>
                                                  <MyTooltip title={"Saisie automatique"}>
                                                       <i
                                                            className={"fas fa-wand-magic-sparkles btn btn-color-dark fs-4 me-sm-2 me-4 p-0"}
                                                            onClick={() =>
                                                                 setModalFillAllRowRefMissionWithHeures({
                                                                      isShown: true,
                                                                      mission_id: item.idMission,
                                                                      mission_ref: item.refMission,
                                                                      matinApremOuNuit: "matin",
                                                                 })
                                                            }
                                                       ></i>
                                                  </MyTooltip>
                                             </>
                                        )}
                                        {item.mission.horaireMatinDebut} - {item.mission.horaireMatinFin}
                                   </td>

                                   <ColumnsHeures item={item} matinApremOuNuit={"matin"} />
                              </tr>
                              {item.mission.typeHoraire === "HORAIRE_ALTERNE_3_PLAGES" && (
                                   <>
                                        <tr>
                                             <td className={"ps-sm-10 border-end sticky-column fw-light fst-italic text-warning"} style={{ fontSize: "0.8rem" }}>
                                                  {editionModeEnabled && (
                                                       <>
                                                            <MyTooltip title={"Saisie automatique"}>
                                                                 <i
                                                                      className={"fas fa-wand-magic-sparkles btn btn-color-dark fs-4 me-sm-2 me-4 p-0"}
                                                                      onClick={() =>
                                                                           setModalFillAllRowRefMissionWithHeures({
                                                                                isShown: true,
                                                                                mission_id: item.idMission,
                                                                                mission_ref: item.refMission,
                                                                                matinApremOuNuit: "aprem",
                                                                           })
                                                                      }
                                                                 ></i>
                                                            </MyTooltip>
                                                       </>
                                                  )}
                                                  {item.mission.horaireApremDebut} - {item.mission.horaireApremFin}
                                             </td>

                                             <ColumnsHeures item={item} matinApremOuNuit={"aprem"} />
                                        </tr>

                                        <tr>
                                             <td className={"ps-sm-10 border-end sticky-column fw-light fst-italic text-warning"} style={{ fontSize: "0.8rem" }}>
                                                  {editionModeEnabled && (
                                                       <>
                                                            <MyTooltip title={"Saisie automatique"}>
                                                                 <i
                                                                      className={"fas fa-wand-magic-sparkles btn btn-color-dark fs-4 me-sm-2 me-4 p-0"}
                                                                      onClick={() =>
                                                                           setModalFillAllRowRefMissionWithHeures({
                                                                                isShown: true,
                                                                                mission_id: item.idMission,
                                                                                mission_ref: item.refMission,
                                                                                matinApremOuNuit: "nuit",
                                                                           })
                                                                      }
                                                                 ></i>
                                                            </MyTooltip>
                                                       </>
                                                  )}
                                                  {item.mission.horaireNuitDebut} - {item.mission.horaireNuitFin}
                                             </td>

                                             <ColumnsHeures item={item} matinApremOuNuit={"nuit"} />
                                        </tr>
                                   </>
                              )}

                              {item.mission.typeHoraire === "HORAIRE_ALTERNE_2_PLAGES_MATIN_APREM" && (
                                   <>
                                        <tr>
                                             <td className={"ps-sm-10 border-end sticky-column fw-light fst-italic text-warning"} style={{ fontSize: "0.8rem" }}>
                                                  {editionModeEnabled && (
                                                       <>
                                                            <MyTooltip title={"Saisie automatique"}>
                                                                 <i
                                                                      className={"fas fa-wand-magic-sparkles btn btn-color-dark fs-4 me-sm-2 me-4 p-0"}
                                                                      onClick={() =>
                                                                           setModalFillAllRowRefMissionWithHeures({
                                                                                isShown: true,
                                                                                mission_id: item.idMission,
                                                                                mission_ref: item.refMission,
                                                                                matinApremOuNuit: "aprem",
                                                                           })
                                                                      }
                                                                 ></i>
                                                            </MyTooltip>
                                                       </>
                                                  )}
                                                  {item.mission.horaireApremDebut} - {item.mission.horaireApremFin}
                                             </td>

                                             <ColumnsHeures item={item} matinApremOuNuit={"aprem"} />
                                        </tr>
                                   </>
                              )}

                              {item.mission.typeHoraire === "HORAIRE_ALTERNE_2_PLAGES_MATIN_NUIT" && (
                                   <>
                                        <tr>
                                             <td className={"ps-sm-10 border-end sticky-column fw-light fst-italic text-warning"} style={{ fontSize: "0.8rem" }}>
                                                  {editionModeEnabled && (
                                                       <>
                                                            <MyTooltip title={"Saisie automatique"}>
                                                                 <i
                                                                      className={"fas fa-wand-magic-sparkles btn btn-color-dark fs-4 me-sm-2 me-4 p-0"}
                                                                      onClick={() =>
                                                                           setModalFillAllRowRefMissionWithHeures({
                                                                                isShown: true,
                                                                                mission_id: item.idMission,
                                                                                mission_ref: item.refMission,
                                                                                matinApremOuNuit: "nuit",
                                                                           })
                                                                      }
                                                                 ></i>
                                                            </MyTooltip>
                                                       </>
                                                  )}
                                                  {item.mission.horaireNuitDebut} - {item.mission.horaireNuitFin}
                                             </td>

                                             <ColumnsHeures item={item} matinApremOuNuit={"nuit"} />
                                        </tr>
                                   </>
                              )}
                         </>
                    ) : (
                         <tr key={key}>
                              {/* First column with ref of the mission + auto complete & suppress buttons */}
                              <td className={"ps-sm-6 border-end sticky-column"} style={{ fontSize: "0.8rem" }}>
                                   {editionModeEnabled && (
                                        <>
                                             <MyTooltip title={"Supprimer cette ligne"}>
                                                  <i
                                                       className={"fas fa-minus-circle btn btn-color-danger fs-2 me-sm-2 me-4 p-0"}
                                                       onClick={() => handleRemoveMissionRow(item.idMission, item.refMission)}
                                                  ></i>
                                             </MyTooltip>
                                             <MyTooltip title={"Saisie automatique"}>
                                                  <i
                                                       className={"fas fa-wand-magic-sparkles btn btn-color-dark fs-2 me-sm-2 me-4 p-0"}
                                                       onClick={() =>
                                                            setModalFillAllRowRefMissionWithHeures({
                                                                 isShown: true,
                                                                 mission_id: item.idMission,
                                                                 mission_ref: item.refMission,
                                                                 matinApremOuNuit:
                                                                      item.mission.typeHoraire === "HORAIRE_NUIT_UNIQUEMENT"
                                                                           ? "nuit"
                                                                           : item.mission.typeHoraire === "HORAIRE_APREM_UNIQUEMENT"
                                                                           ? "aprem"
                                                                           : "matin",
                                                            })
                                                       }
                                                  ></i>
                                             </MyTooltip>
                                        </>
                                   )}
                                   {item.refMission}
                              </td>

                              <ColumnsHeures
                                   item={item}
                                   matinApremOuNuit={
                                        item.mission.typeHoraire === "HORAIRE_NUIT_UNIQUEMENT"
                                             ? "nuit"
                                             : item.mission.typeHoraire === "HORAIRE_APREM_UNIQUEMENT"
                                             ? "aprem"
                                             : "matin"
                                   }
                              />
                         </tr>
                    )
               )}
          </>
     )
}

export default TbodyTrHeuresTravailParRefMission
